// Module
var code = "<section class=\"system-clock\" ng-click=\"toggleDateFormat()\" ng-class=\"{ 'system-date': !isShortDate }\"> {{ localDate | date: getDateFormat() }} </section> ";
// Exports
export default code;